import { render, staticRenderFns } from "./ReviewAndSubmitStep.vue?vue&type=template&id=56c57444&scoped=true&"
import script from "./ReviewAndSubmitStep.vue?vue&type=script&lang=js&"
export * from "./ReviewAndSubmitStep.vue?vue&type=script&lang=js&"
import style0 from "./ReviewAndSubmitStep.vue?vue&type=style&index=0&id=56c57444&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c57444",
  null
  
)

export default component.exports